import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_Q1aRLGmyYjfz: {
	id: 'prd_Q1aRL2DEV2GmyYjfz'
	ident: 'prd_Q1aRLGmyYjfz'
	sku: 'simple_premium_4w_7_99_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_XbUDS2DEV2zsYEEdh'
			amount: 44
			amount_usd: 7.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 7.99
			discount: 36.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_f9zcp2DEV2g6KcLDd'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_Q1aRLGmyYjfz, SubscriptionProduct>
const prd_Q1aRLGmyYjfz = { ident: 'prd_Q1aRLGmyYjfz' } as typeof _prd_Q1aRLGmyYjfz

export default prd_Q1aRLGmyYjfz
